// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-index-js": () => import("./../../../src/pages/404/index.js" /* webpackChunkName: "component---src-pages-404-index-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-people-index-js": () => import("./../../../src/pages/people/index.js" /* webpackChunkName: "component---src-pages-people-index-js" */),
  "component---src-pages-publications-index-js": () => import("./../../../src/pages/publications/index.js" /* webpackChunkName: "component---src-pages-publications-index-js" */)
}

